import React, { useEffect, useState } from "react";
import { useSidebar } from "../../context/SidebarContext";
import { useNavigate } from "react-router-dom";
import { CiMaximize1, CiMinimize1 } from "react-icons/ci";
import { LuMinimize } from "react-icons/lu";
import { CgMaximize } from "react-icons/cg";
import { LiaCogSolid } from "react-icons/lia";

export default function Navbar() {
  const [isFullScreen, setIsFullScreen] = useState(false);
  const { toggleSidebarWidth, sidebarWidth } = useSidebar();
  const navigate = useNavigate(null);

  // Listen for changes in fullscreen status
  useEffect(() => {
    const onFullScreenChange = () => {
      setIsFullScreen(!!document.fullscreenElement); // Update isFullScreen based on whether fullscreen is active
    };

    document.addEventListener("fullscreenchange", onFullScreenChange);

    // Clean up event listener on unmount
    return () => {
      document.removeEventListener("fullscreenchange", onFullScreenChange);
    };
  }, []);

  const handleFullscreen = () => {
    const element = document.documentElement; // Select the whole page (or any specific element)

    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.mozRequestFullScreen) {
      // For Firefox
      element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) {
      // For Chrome, Safari, and Opera
      element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) {
      // For IE/Edge
      element.msRequestFullscreen();
    }
    setIsFullScreen(true);
  };

  const handleExitFullscreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
    setIsFullScreen(false);
  };

  const handleLogout = () => {
    // Implement logout logic
    localStorage.removeItem("sansadToken");
    // Redirect to login page
    navigate('/admin-panel/login');
  };

  return (
    <div className="h-[80px] bg-white shadow-md w-full flex justify-between items-center px-6 sticky top-0 z-10">
      <div className="">
        <button onClick={toggleSidebarWidth} className="!outline-none">
          <i className="fa fa-bars text-xl text-[#454444]"></i>
        </button>
      </div>
      <div className="md:flex hidden justify-center gap-6">
        {isFullScreen ? (
          <button onClick={handleExitFullscreen}>
            {/* <i className="fa fa-window-minimize text-md text-[#454444]"></i> */}
            <LuMinimize size={18} />
          </button>
        ) : (
          <button onClick={handleFullscreen}>
            {/* <i className="fa fa-window-maximize text-md text-[#454444]"></i> */}
            <CgMaximize size={18} />
          </button>
        )}

        {/* <button>
          <LiaCogSolid size={18} />

        </button> */}
        <button onClick={handleLogout}>
          <i className="fa fa-sign-out text-xl text-[#454444]"></i>
        </button>
      </div>
    </div>
  );
}

/*
The Fullscreen API allows you to request full-screen mode and listen for changes in full-screen status. Key properties and methods include:

document.fullscreenElement: Tracks the element in full-screen mode or null if not in full screen.
document.documentElement.requestFullscreen(): Requests full-screen mode.
document.exitFullscreen(): Exits full-screen mode.
*/
